import { Select } from 'twyne-new.ui';

import { getChange, getValue } from './utils';

export default function SelectFilter({ isMulti, options, onChange, name, value, Component = Select, creatable = false }) {
  const isCreatable = typeof creatable === 'boolean' ? creatable : false
  return <Component
    id={name}
    options={options}
    value={getValue(value, isMulti)}
    onChange={getChange(onChange, isMulti)}
    clearable
    creatable={isCreatable}
  />
}
